var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobot1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8857 76.542H25.8736V63.4882C25.8736 58.2115 30.1666 53.9185 35.4434 53.9185H40.0207V58.9306H35.4434C32.9302 58.9306 30.8857 60.9753 30.8857 63.4885V76.542Z",
    fill: "#6DB9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2926 90.1353L30.0007 85.678C31.1936 85.0646 31.9345 83.8525 31.9345 82.5149C31.9345 80.5548 30.3398 78.9601 28.3797 78.9601C26.4197 78.9601 24.825 80.5548 24.825 82.5149C24.825 83.8527 25.5661 85.0646 26.759 85.678L24.4668 90.1353C21.5962 88.6593 19.8129 85.7392 19.8129 82.5149C19.8129 77.791 23.6559 73.948 28.3797 73.948C33.1036 73.948 36.9466 77.791 36.9466 82.5149C36.9466 85.7392 35.1633 88.659 32.2926 90.1353Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1264 76.542H89.1143V63.4882C89.1143 60.975 87.0698 58.9303 84.5566 58.9303H79.9793V53.9182H84.5566C89.8334 53.9182 94.1264 58.2113 94.1264 63.488V76.542Z",
    fill: "#127EC3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5333 90.1356L93.2414 85.6783C94.4344 85.0649 95.1752 83.8527 95.1752 82.5151C95.1752 80.555 93.5805 78.9604 91.6205 78.9604C89.6604 78.9604 88.0655 80.555 88.0655 82.5151C88.0655 83.8529 88.8065 85.0649 89.9993 85.6783L87.7071 90.1356C84.8365 88.6595 83.0531 85.7394 83.0531 82.5151C83.0531 77.7913 86.8961 73.9482 91.62 73.9482C96.3438 73.9482 100.187 77.7913 100.187 82.5151C100.187 85.7394 98.404 88.6593 95.5333 90.1356Z",
    fill: "#E0E0E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5371 101.971H51.303C48.735 101.971 46.634 99.8703 46.634 97.3025V80.1584H58.2061V97.3023C58.2063 99.8703 56.1051 101.971 53.5371 101.971Z",
    fill: "#6DB9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6966 101.972H66.4626C63.8945 101.972 61.7936 99.8706 61.7936 97.3028V80.1587H73.3656V97.3025C73.3659 99.8706 71.2647 101.972 68.6966 101.972Z",
    fill: "#127EC3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3266 43.9314H52.6758V50.1386H67.3266V43.9314Z",
    fill: "#6DB9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3266 43.9312H60V50.1374H67.3266V43.9312Z",
    fill: "#127EC3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3173 44.2043H45.6827C41.7677 44.2043 38.5645 41.0011 38.5645 37.0861V23.9934C38.5645 20.0784 41.7677 16.8752 45.6827 16.8752L74.317 16.8752C78.232 16.8752 81.4352 20.0784 81.4352 23.9934V37.0861C81.4355 41.0011 78.2323 44.2043 74.3173 44.2043Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M81.436 23.993V37.0852C81.436 41.0016 78.232 44.2031 74.318 44.2031H60V16.875H74.318C78.232 16.875 81.436 20.0789 81.436 23.993Z",
    fill: "#E0E0E2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3173 82.1803H45.6827C41.7677 82.1803 38.5645 78.9771 38.5645 75.0621V57.0516C38.5645 53.1366 41.7677 49.9333 45.6827 49.9333H74.317C78.232 49.9333 81.4352 53.1366 81.4352 57.0516V75.0621C81.4355 78.9771 78.2323 82.1803 74.3173 82.1803Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4359 57.0516V75.0609C81.4359 78.9773 78.232 82.1812 74.318 82.1812H60V49.9336H74.318C78.232 49.9336 81.4359 53.1375 81.4359 57.0516Z",
    fill: "#E0E0E2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.807 24.2954H46.1953V34.5409H73.807V24.2954Z",
    fill: "#6DB9FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8047 24.293H60V34.5398H73.8047V24.293Z",
    fill: "#127EC3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#127EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#127EC3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot1);
export default __webpack_public_path__ + "static/media/robot1.77107ad4dc9d4cecdabb2382ce983554.svg";
export { ForwardRef as ReactComponent };